import {en} from "../../config/locales/views/web/javascript/en.yml"
import {pt} from "../../config/locales/views/web/javascript/pt.yml"

export default { en, pt }
